import { render, staticRenderFns } from "./generateinvoice.vue?vue&type=template&id=4be191a2"
import script from "./generateinvoice.vue?vue&type=script&lang=js"
export * from "./generateinvoice.vue?vue&type=script&lang=js"
import style0 from "./generateinvoice.vue?vue&type=style&index=0&id=4be191a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports